import React from "react";
import Form from "../components/Form";
import styled, { keyframes } from "styled-components";

const FormPage = () => {
  return (
    <PageWrapper>
      <Decorative>
        <Shape className="circle" top="10%" left="5%" />
        <Shape className="triangle" top="70%" left="10%" />
        <Shape className="square" top="50%" right="10%" />
        <Icon src="/assets/coin.svg" top="20%" right="20%" />
        <Icon src="/assets/calculator.svg" bottom="10%" left="20%" />
      </Decorative>
      <FormContainer>
        <Form />
      </FormContainer>
    </PageWrapper>
  );
};

export default FormPage;

// ======= Styled Components =======

const float = keyframes`
  0% { transform: translateY(0px) rotate(0deg); }
  50% { transform: translateY(-10px) rotate(5deg); }
  100% { transform: translateY(0px) rotate(0deg); }
`;

const PageWrapper = styled.div`
  position: relative;
  width: 100%;
  min-height: 100vh;
  /* background: #e9ecef; */
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  padding: 40px;
`;

const Decorative = styled.div`
  position: absolute;
  inset: 0;
  pointer-events: none;

  @media (max-width: 768px) {
    display: none;
  }
`;

const Shape = styled.div`
  position: absolute;
  width: 40px;
  height: 40px;
  background: ${(props) =>
    props.className === "circle"
      ? "#00c3a5"
      : props.className === "triangle"
        ? "#ffbb00"
        : "#0072bb"};
  border-radius: ${(props) =>
    props.className === "circle"
      ? "50%"
      : props.className === "triangle"
        ? "0"
        : "8px"};
  clip-path: ${(props) =>
    props.className === "triangle"
      ? "polygon(50% 0%, 0% 100%, 100% 100%)"
      : "none"};
  top: ${(props) => props.top || "auto"};
  bottom: ${(props) => props.bottom || "auto"};
  left: ${(props) => props.left || "auto"};
  right: ${(props) => props.right || "auto"};
  opacity: 0.2;
  animation: ${float} 6s ease-in-out infinite;
`;

const Icon = styled.img`
  position: absolute;
  width: 50px;
  height: 50px;
  top: ${(props) => props.top || "auto"};
  bottom: ${(props) => props.bottom || "auto"};
  left: ${(props) => props.left || "auto"};
  right: ${(props) => props.right || "auto"};
  opacity: 0.08;
  animation: ${float} 10s ease-in-out infinite;
`;

const FormContainer = styled.div`
  position: relative;
  /* background: #e9ecef; */
  border-radius: 12px;
  padding: 50px;
  box-shadow: 0 12px 30px rgba(0, 0, 0, 0.1);
  z-index: 2;
  width: 100%;
  max-width: 800px;

  @media (max-width: 768px) {
    padding: 30px;
  }
`;
